// eslint-disable-next-line import/prefer-default-export
export enum AdIdentifier {
  COUNTDOWN_02 = 'freemium_upgrade_modal_with_countdown_2',
  COUNTDOWN_03 = 'freemium_upgrade_modal_with_countdown_3',
  GEAR_DISCOUNT = 'freemium_upgrade_modal_4',
  MUSTANG_MICRO_BUNDLE = 'freemium_upgrade_modal_5',
}

export type Ad = {
  adIdentifier: AdIdentifier;
  desktop: string;
  mobile: string;
  alt: string;
  adCopy: string[];
};

export interface FreemiumAdProps {
  onDismiss: () => void;
  onUpgrade: () => void;
  isMobile?: boolean;
  ad: Ad;
  showLargeHeadline: boolean;
}
